

export  const FormatePrice = (number) => {

  if (number >= 1e6) {
    return (number / 1e6).toFixed(1).replace(/\.0$/, '') + 'M';
  }
  if (number >= 1e3) {
    return (number / 1e3).toFixed(1).replace(/\.0$/, '') + 'K';
  }
  return number;


}

export default FormatePrice;